var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("hr", { staticClass: "emd-divider" }),
    _c("div", { staticClass: "eu-pa_3 eu-pa_5_md eu-flex" }, [
      _c(
        "span",
        {
          staticClass:
            "summary-title eu-flex-item eu-basis_12 eu-basis_12_md eu-pb_2",
        },
        [_vm._v(_vm._s(_vm.$t("paymentMethods")))]
      ),
      _vm.paymentMethods.credit_card_enabled
        ? _c(
            "span",
            {
              staticClass:
                "summary-content eu-flex-item eu-basis_12 eu-basis_12_md eu-py_1_md",
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("creditCard")) +
                  " (" +
                  _vm._s(
                    _vm.$t("in", {
                      installment: _vm.creditCardSettings.max_installments,
                    })
                  ) +
                  ") "
              ),
            ]
          )
        : _vm._e(),
      _vm.paymentMethods.boleto_enabled
        ? _c(
            "span",
            {
              staticClass:
                "summary-content eu-flex-item eu-basis_12 eu-basis_12_md eu-py_1_md",
            },
            [_vm._v(" " + _vm._s(_vm.$t("boleto")) + " ")]
          )
        : _vm._e(),
      _vm.paymentMethods.pix_enabled
        ? _c(
            "span",
            {
              staticClass:
                "summary-content eu-flex-item eu-basis_12 eu-basis_12_md eu-py_1_md",
            },
            [_vm._v(" " + _vm._s(_vm.$t("pix")) + " ")]
          )
        : _vm._e(),
      _vm.noPaymentMethods
        ? _c(
            "span",
            {
              staticClass:
                "summary-content eu-flex-item eu-basis_12 eu-basis_12_md eu-py_1_md",
            },
            [_vm._v(" - ")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }